<div class="menu-item" [class.menu-item__active]="isActive">
  @if (menuItem.icon) {
    <cm-icon [name]="menuItem.icon" class="menu-item__icon" />
  }
  {{ menuItem.label }}
</div>

<ul class="dropdown-menu" [class.dropdown-menu__last]="isLast">
  @for (row of menuItem.dropdownMenu; track row) {
    <li class="dropdown-menu-row">
      <a
        class="dropdown-menu-row__primary-link"
        [routerLink]="row.primaryLink.link"
        [queryParams]="row.primaryLink.queryParams"
      >
        {{ row.primaryLink.label }}
      </a>
      @if (row.secondaryLink) {
        <a
          class="dropdown-menu-row__secondary-link"
          [routerLink]="row.secondaryLink.link"
          [queryParams]="row.secondaryLink.queryParams"
        >
          {{ row.secondaryLink.label }}
        </a>
      }
    </li>
  }
</ul>
